import React, { useCallback, useMemo } from "react";

function normalizeValue(value) {
    if (Array.isArray(value)) {
        return value
            .map((item) => String(item ?? "").trim())
            .filter((item) => item && item !== "0");
    }

    const single = String(value ?? "").trim();
    if (!single || single === "0") {
        return [];
    }

    if (single.includes(",")) {
        return single.split(",")
            .map((item) => item.trim())
            .filter((item) => item && item !== "0");
    }

    return [single];
}

export default function OptionMultiSelect({
    options,
    value,
    onChange,
    className = "",
    invalid = false,
    id,
    "aria-label": ariaLabel,
}) {
    const selectedSet = useMemo(() => new Set(normalizeValue(value)), [value]);

    const toggle = useCallback((optionValue) => {
        const key = String(optionValue);
        const next = new Set(selectedSet);
        if (next.has(key)) {
            next.delete(key);
        } else {
            next.add(key);
        }
        onChange(Array.from(next));
    }, [onChange, selectedSet]);

    return (
        <div
            id={id}
            className={`option-multi-select${invalid ? " is-invalid" : ""}${className ? ` ${className}` : ""}`}
            role="group"
            aria-label={ariaLabel}
        >
            {options.map((option) => {
                const key = String(option.value);
                const selected = selectedSet.has(key);
                return (
                    <button
                        key={key}
                        type="button"
                        className={`option-multi-select__option${selected ? " is-selected" : ""}`}
                        aria-pressed={selected}
                        onClick={() => toggle(key)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
